import type * as Y from 'yjs';
import { isUuid } from './ids';
import { parseObject } from './schema';
import { readObject } from './ytypes';

/**
 * Asset ids the document's valid objects use, each once (`board_asset_refs`, spec §10.2): images and the preview images
 * of link cards and embeds. Non-uuid ids are local-only.
 */
export function extractAssetIds(doc: Y.Doc): string[] {
  const ids = new Set<string>();
  doc.getMap<Y.Map<unknown>>('objects').forEach((m, id) => {
    const o = parseObject({ ...readObject(m), id });
    const asset = o?.type === 'image' ? o.assetId : o?.type === 'link' || o?.type === 'embed' ? o.thumbAssetId : null;
    if (asset && isUuid(asset)) ids.add(asset);
  });
  return [...ids];
}

/** The width/height ratio an image object shows undistorted: its asset's, times its crop (fractions of the source). */
export function imageAspect(asset: { w: number; h: number }, crop: { w: number; h: number }): number {
  return (asset.w * crop.w) / (asset.h * crop.h);
}
